import { createContext, Dispatch } from 'react'
import { BriefState } from '../../Hooks/Brief/useBrief/useBrief'

export interface GlobalBriefState extends BriefState {
  showBizLayout: boolean
  setShowBizLayout: Dispatch<React.SetStateAction<boolean>>
}

const BriefContext = createContext<GlobalBriefState | undefined>(undefined)

export default BriefContext
